
import Happyemoji from "../../../assets/filled/Happyemoji.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function HappyemojiIcon({ className, dataTestid = "HappyemojiIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Happyemoji data-testid={dataTestid} className={classes} {...rest} />
  );
}
